import SecurePaymentService from "../services/SecurePaymentService";
import {enableSuccessToastInfo,showMemoApiErrorMessage,showNoWalletEventErrorMessage} from "./ToastActions";
import {setAdobeAnalyticsDataForErrorEventTracking} from "../services/analytics-util";


export function updateToken(tokenDetails, analysticsObj) {
    return function (dispatch,getState) {
        SecurePaymentService.updateToken(tokenDetails)
            .then(res => {
                if (res.data) {
                    //show toast message
                    dispatch(showNoWalletEventErrorMessage(false));
                    dispatch(enableSuccessToastInfo(true));
                    dispatch(tokenUpdateSuccess(true));
                    dispatch(setLoderStatus(false));
                }
            }).catch(function (error) {
            setAdobeAnalyticsDataForErrorEventTracking(analysticsObj);
            dispatch(showMemoApiErrorMessage(true));
            dispatch(setLoderStatus(false));
        });
    };
}

export const tokenUpdateSuccess = (flag) =>{
    return{
        type:'SET_TOKEN_UPDATE_SUCCESS',
        value:flag
    }
};

export const setLoderStatus = (flag) =>{
    return{
        type:'SET_LOADER_STATUS',
        value:flag
    }
};

/** Replaces the in-memory PI parity payment event trail (used when building the next Hendrix payload). */
export const setPiParityPaymentEventsLog = (records) => ({
    type: 'SET_PI_PARITY_PAYMENT_EVENTS_LOG',
    records,
});

export const clearPiParityPaymentEventsLog = () => ({
    type: 'CLEAR_PI_PARITY_PAYMENT_EVENTS_LOG',
});